import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

const NewRegArabic = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const handleFormSubmit = (data) => {
    const sn = parseInt(data.sn);
    const batch = parseInt(data.batch);
    const level = parseInt(data["arabic-level"]);
    const exmNo = parseInt(data.total_exm);

    const insertData = {
      sn: sn,
      name: data.fullName.toLowerCase(),
      fatherName: data.fatherName.toLowerCase(),
      phone: data.phone,
      gender: data.gender,
      [`arabicPayment`]: data.payment_date,
      [`arabic${level}skill`]: [
        { name: "Reading", value: 30 },
        { name: "Writing", value: 30 },
        { name: "Listening", value: 30 },
        { name: "Speaking", value: 30 },
      ],
      [`arabic${level}data`]: Array.from({ length: exmNo }, (_, i) => ({
        name: `Exm ${i + 1}`,
        Score: 0,
      })),
    };

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_API}/arabic/${batch}/register`,
        insertData
      )
      .then((data) => {
        toast.success(insertData.name.toUpperCase());
        reset();
      });
  };
  return (
    <div className="min-h-screen container mx-auto my-10 px-5">
      <p className="text-center text-2xl text-primary">Register New Student</p>
      <div className="card flex-shrink-0 w-full  shadow-2xl bg-base-100">
        <div className="card-body">
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <div className="flex gap-5">
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Batch No</span>
                      <span className="ml-2 mr-auto text-red-500">
                        {errors.batch?.type === "required" && "Required"}
                      </span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        defaultValue={5}
                        className="input input-bordered w-full"
                        {...register("batch", { required: true })}
                      />
                    </div>
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">SN</span>
                      <span className="ml-2 mr-auto text-red-500">
                        {errors.sn?.type === "required" && "Required"}
                      </span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        placeholder="SN"
                        className="input input-bordered w-20"
                        {...register("sn", { required: true })}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Full Name</span>
                    <span className="ml-2 mr-auto text-red-500">
                      {errors.fullName?.type === "required" && "Required!"}
                    </span>
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      placeholder="Full Name"
                      className="input input-bordered w-full max-w-xs"
                      {...register("fullName", { required: true })}
                    />
                  </div>
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Father's Name</span>
                    <span className="ml-2 mr-auto text-red-500">
                      {errors.fatherName?.type === "required" && "Required"}
                    </span>
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      placeholder="Father's Name"
                      className="input input-bordered w-full max-w-xs"
                      {...register("fatherName", { required: true })}
                    />
                  </div>
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Phone</span>
                    <span className="ml-2 mr-auto text-red-500">
                      {errors.phone?.type === "required" && "Required"}
                    </span>
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      placeholder="****"
                      className="input input-bordered w-full max-w-xs"
                      {...register("phone", { required: true })}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="flex gap-20">
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Gender</span>
                      <span className="ml-2 mr-auto text-red-500">
                        {errors.gender?.type === "required" && "Required!"}
                      </span>
                    </label>
                    <label
                      htmlFor="field-male"
                      className="flex align-center mb-1"
                    >
                      <input
                        {...register("gender")}
                        type="radio"
                        name="gender"
                        value="male"
                        id="field-male"
                        className="radio mr-3 checked:bg-sky-500"
                      />
                      <span>Male</span>
                    </label>
                    <label
                      htmlFor="field-female"
                      className="flex align-center mb-1"
                    >
                      <input
                        {...register("gender")}
                        type="radio"
                        name="gender"
                        value="female"
                        id="field-female"
                        className="radio mr-3 checked:bg-pink-500"
                      />
                      <span>Female</span>
                    </label>
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Level</span>
                    </label>
                    <label
                      htmlFor="field-arabic-level1"
                      className="flex align-center mb-1"
                    >
                      <input
                        {...register("arabic-level")}
                        type="radio"
                        name="arabic-level"
                        value={1}
                        id="field-arabic-level1"
                        className="radio mr-3 checked:bg-purple-500"
                      />
                      <span>Level 1</span>
                    </label>
                    <label
                      htmlFor="field-arabic-level2"
                      className="flex align-center mb-1"
                    >
                      <input
                        {...register("arabic-level")}
                        type="radio"
                        name="arabic-level"
                        value={2}
                        id="field-arabic-level2"
                        className="radio mr-3 checked:bg-amber-500"
                      />
                      <span>Level 2</span>
                    </label>
                    <label
                      htmlFor="field-arabic-level3"
                      className="flex align-center mb-1"
                    >
                      <input
                        {...register("arabic-level")}
                        type="radio"
                        name="arabic-level"
                        value={3}
                        id="field-arabic-level3"
                        className="radio mr-3 checked:bg-green-500"
                      />
                      <span>Level 3</span>
                    </label>
                  </div>
                </div>
                <div className="flex gap-5 my-10">
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Payment Date</span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        // defaultValue={new Date().toISOString().split("T")[0]}
                        defaultValue={"2025-05-10"}
                        className="input input-bordered w-full"
                        {...register("payment_date", { required: true })}
                      />
                      {errors.payment_date?.type === "required" &&
                        "Payemnt Date is required"}
                    </div>
                  </div>
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text">Total Exm</span>
                    </label>
                    <div className="mb-3">
                      <input
                        type="text"
                        defaultValue={8}
                        className="input input-bordered w-20"
                        {...register("total_exm", { required: true })}
                      />
                      {errors.total_exm?.type === "required" &&
                        "How many exams are there?"}
                    </div>
                  </div>
                </div>

                <div className="form-control mt-10">
                  <button
                    type="submit"
                    className="btn btn-primary w-full max-w-xs"
                  >
                    Register
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewRegArabic;
